// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".flex\n{\n    display: flex;\n}\n\n.flex-c\n{\n    display: flex;\n    flex-direction: column;\n}", "",{"version":3,"sources":["webpack://src/assets/global/styles.css"],"names":[],"mappings":"AAAA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,aAAa;IACb,sBAAsB;AAC1B","sourcesContent":[".flex\n{\n    display: flex;\n}\n\n.flex-c\n{\n    display: flex;\n    flex-direction: column;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
